<template>
    <div class="jxlDetails">
        <div class="item" v-for="(item, index) in list" :key="index">
            <dl>
                <dt>{{item.key}}</dt>
                <dd v-html="item.value" />
            </dl>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                productCode: "",
                token: "",
                list:[]
            };
        },
        created() {
            let params = this.$queryUrl(location.href);
            const {token, productCode} = params;
            this.token = decodeURIComponent(token||"");
            this.productCode = decodeURIComponent(productCode);
            (async function () {
                try {
                    const {data, msg} = await this.$request({
                        url: "/hjiaProduct/detail.json",
                        data: this.$qs.stringify({
                            productCode,
                            token:this.token
                        })
                    });
                    this.list = data.jiaDetail.map(item => {
                        item.value = item.value.replace(/[\n\r]+/g, "<br />");
                        return item
                    });
                }catch (e) {
                    this.$toast(e.message)
                }

            }.bind(this))();

        },
        methods: {

        }
    };
</script>
<style lang="less">
    .jxlDetails {
        height: 100vh;
        background: #fbfbfb;

        .item {
            background: #FFFFFF;
            padding: 0 16px;

            &:last-child {
                dl {
                    border: 0;
                }
            }
        }

        dl {
            font-size: 14px;
            display: flex;
            padding: 15px 0;

            border-bottom: 1px solid #ebebeb;
        }

        dt {
            color: #aaaaaa;
        }

        dd {
            flex: 1;
            text-align: right;
        }
    }
</style>
